import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';

import {
  PATIENT_PACKAGE,
  PATIENT_PACKAGE_CLOSE_LIST,
  PATIENT_PACKAGE_INACTIVATE_FINISHED,
  PATIENT_PACKAGE_SHOW_LIST
} from './patientPackageActions';

const handleError = (state, action) => {
  return updateResourceState(state, action, RESOURCE, () => ({
    loading: false,
    saving: false
  }));
};

const patientPackageReducer = createResourceReducer(
  PATIENT_PACKAGE,
  [],
  {
    [PATIENT_PACKAGE_SHOW_LIST](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        currentPatient: action.payload,
        showPackageList: true
      }));
    },

    [PATIENT_PACKAGE_CLOSE_LIST](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        currentPatient: null,
        showPackageList: false
      }));
    },

    [PATIENT_PACKAGE_INACTIVATE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    }
  },
  handleError
);

export default patientPackageReducer;
